import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { useTheme } from '@/context/ThemeContext'
import Footer from '@/components/Frontside/Footer'
import ProjectDetailRich from '@/components/project-detail/ProjectDetailRich'
import { supabase } from '@/lib/supabase'
import { normalizeHubPublicProject } from '@/lib/projectDisplay'

export default function HubProjectPublicPage() {
  const { slug } = useParams()
  const { setTheme } = useTheme()
  const [project, setProject] = useState(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  useEffect(() => {
    setTheme('light')
  }, [setTheme])

  useEffect(() => {
    if (!slug) return
    let cancelled = false
    ;(async () => {
      setLoading(true)
      setError(null)
      const { data, error: rpcErr } = await supabase.rpc('get_hub_project_public_by_slug', {
        p_slug: slug,
      })
      if (cancelled) return
      if (rpcErr) {
        setError(rpcErr.message)
        setProject(null)
      } else if (!data) {
        setError('Project not found or not published.')
        setProject(null)
      } else {
        setProject(data)
      }
      setLoading(false)
    })()
    return () => {
      cancelled = true
    }
  }, [slug])

  if (loading) {
    return (
      <div className="frontside-page flex min-h-screen flex-col bg-background text-foreground">
        <p className="flex flex-1 items-center justify-center text-muted-foreground">Loading…</p>
      </div>
    )
  }

  if (error || !project) {
    return (
      <div className="frontside-page flex min-h-screen flex-col bg-background text-foreground">
        <div className="flex flex-1 flex-col items-center justify-center px-4">
          <p className="text-destructive text-sm">{error || 'Not found'}</p>
        </div>
        <Footer />
      </div>
    )
  }

  const detail = normalizeHubPublicProject(project)

  return (
    <>
      <ProjectDetailRich
        detail={detail}
        backTo={{ to: '/#projects', label: '← Back to projects' }}
      />
      <Footer />
    </>
  )
}
